/* BASIN Design Contest voting page. Invited voters ask for an emailed code,
   sign in with it, then rank their top designs. Designers stay anonymous: the
   API never sends names to this page. */
(function () {
  var PLACES = ['1st', '2nd', '3rd', '4th', '5th'];

  // Give `id` the rank `place` (1-based), or clear it with 0. A rank belongs to
  // one design at a time, so taking it moves it off whichever design had it.
  function setRank(ranks, id, place) {
    var next = {};
    Object.keys(ranks).forEach(function (other) {
      if (other !== id && ranks[other] !== place) next[other] = ranks[other];
    });
    if (place) next[id] = place;
    return next;
  }

  // The ballot to send: design ids in rank order, once every place is filled.
  function ranking(ranks, picks) {
    var ordered = [];
    Object.keys(ranks).forEach(function (id) { ordered[ranks[id] - 1] = id; });
    for (var i = 0; i < picks; i++) if (!ordered[i]) return null;
    return ordered.slice(0, picks);
  }

  // A saved ranking as ranks, keeping only designs still on the ballot and
  // places that still exist (a design can be withdrawn after someone votes).
  function fromRanking(list, designs, picks) {
    var onBallot = {}, ranks = {};
    (designs || []).forEach(function (design) { onBallot[design.id] = true; });
    (list || []).forEach(function (id, index) {
      if (onBallot[id] && index < picks) ranks[id] = index + 1;
    });
    return ranks;
  }

  function fallback(help) {
    return 'Something went wrong. Please try again, or email ' + help + '.';
  }

  function call(deps, method, path, body, token) {
    var headers = {};
    if (body) headers['Content-Type'] = 'application/json';
    if (token) headers.Authorization = 'Bearer ' + token;
    return deps.fetch(deps.api + path, { method: method, headers: headers, body: body ? JSON.stringify(body) : undefined })
      .then(function (response) {
        return response.json().catch(function () { return null; }).then(function (answer) {
          if (response.ok) return answer;
          var error = new Error((answer && answer.detail && answer.detail.message) || fallback(deps.help));
          error.code = answer && answer.detail && answer.detail.code;
          throw error;
        });
      }, function () { throw new Error(fallback(deps.help)); });
  }

  function remember(token) {
    try { if (token) window.sessionStorage.setItem('dcVoteToken', token); else window.sessionStorage.removeItem('dcVoteToken'); } catch (e) { /* private mode */ }
  }
  function recall() {
    try { return window.sessionStorage.getItem('dcVoteToken'); } catch (e) { return null; }
  }

  function mount(root) {
    var deps = { api: root.getAttribute('data-api'), help: root.getAttribute('data-help'), fetch: window.fetch.bind(window) };
    var el = function (name) { return root.querySelector('[data-dv="' + name + '"]'); };
    var token = recall(), email = '', ballot = null, ranks = {};
    var show = function (state, message) {
      root.setAttribute('data-dv-state', state);
      el('error').textContent = message || '';
      el('error').hidden = !message;
    };
    var fail = function (state) {
      return function (error) {
        if (error.code === 'signed_out') { token = null; remember(null); show('email', 'Please sign in again.'); return; }
        // Before or after the window, the page itself says so: no red error box too.
        if (error.code === 'closed' || error.code === 'not_open') { el('over').textContent = error.message; show('over'); return; }
        show(state, error.message);
      };
    };

    function card(design) {
      var item = document.createElement('li');
      item.className = 'dv-card';
      var head = document.createElement('div');
      head.className = 'dv-head';
      var number = document.createElement('strong');
      number.textContent = 'Design ' + design.number;
      var select = document.createElement('select');
      select.setAttribute('aria-label', 'Rank for design ' + design.number);
      var none = document.createElement('option');
      none.value = '0'; none.textContent = 'Not ranked';
      select.appendChild(none);
      for (var p = 1; p <= ballot.picks; p++) {
        var option = document.createElement('option');
        option.value = String(p); option.textContent = PLACES[p - 1];
        select.appendChild(option);
      }
      select.value = String(ranks[design.id] || 0);
      select.addEventListener('change', function () {
        ranks = setRank(ranks, design.id, Number(select.value));
        draw();
      });
      head.appendChild(number); head.appendChild(select);
      item.appendChild(head);
      [['front', 'Front'], ['back', 'Back']].forEach(function (side) {
        if (side[0] === 'back' && !design.has_back) return;
        var url = design[side[0]];
        var frame = document.createElement('div');
        frame.className = 'dv-art';
        if (url) {
          var img = document.createElement('img');
          img.src = url; img.alt = 'Design ' + design.number + ', ' + side[1].toLowerCase(); img.loading = 'lazy';
          frame.appendChild(img);
        } else {
          frame.textContent = side[1] + ' preview coming soon';
          frame.className += ' is-missing';
        }
        item.appendChild(frame);
      });
      if (design.title) { var title = document.createElement('p'); title.className = 'dv-title'; title.textContent = design.title; item.appendChild(title); }
      if (design.notes) { var notes = document.createElement('p'); notes.className = 'dv-notes'; notes.textContent = design.notes; item.appendChild(notes); }
      if (ranks[design.id]) item.className += ' is-ranked';
      return item;
    }

    function draw() {
      var list = el('designs');
      list.textContent = '';
      ballot.designs.forEach(function (design) { list.appendChild(card(design)); });
      var done = Object.keys(ranks).length;
      el('count').textContent = done + ' of ' + ballot.picks + ' ranked';
      el('submit').disabled = !ranking(ranks, ballot.picks);
    }

    function load() {
      show('loading');
      return call(deps, 'GET', '/vote/ballot', null, token).then(function (answer) {
        ballot = answer;
        ranks = fromRanking(answer.ranking, answer.designs, answer.picks);
        el('picks').textContent = String(answer.picks);
        if (!answer.designs.length) { show('over'); el('over').textContent = 'There are no designs to vote on yet.'; return; }
        draw();
        show('ballot');
      }, fail('email'));
    }

    el('email-form').addEventListener('submit', function (event) {
      event.preventDefault();
      email = el('email-input').value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { show('email', 'Enter a valid email address.'); return; }
      call(deps, 'POST', '/vote/code', { email: email }).then(function () {
        el('sent-to').textContent = email;
        show('code');
      }, fail('email'));
    });
    el('code-form').addEventListener('submit', function (event) {
      event.preventDefault();
      call(deps, 'POST', '/vote/session', { email: email, code: el('code-input').value.trim() }).then(function (answer) {
        token = answer.token; remember(token); load();
      }, fail('code'));
    });
    el('restart').addEventListener('click', function () { show('email'); });
    el('submit').addEventListener('click', function () {
      var list = ranking(ranks, ballot.picks);
      if (!list) return;
      el('submit').disabled = true;
      call(deps, 'POST', '/vote', { ranking: list }, token).then(function () {
        show('saved');
      }, function (error) { el('submit').disabled = false; fail('ballot')(error); });
    });
    el('change').addEventListener('click', function () { draw(); show('ballot'); });

    if (token) load(); else show('email');
  }

  window.BasinDesignContestVote = { setRank: setRank, ranking: ranking, fromRanking: fromRanking, call: call };

  function start() { Array.prototype.forEach.call(document.querySelectorAll('[data-design-contest-vote]'), mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
